<template>
  <div>
    <div class="block summary">
      <div class="summary__secondary-title">JOUW SAMENSTELLING</div>
      <h3 class="summary__title">Jouw keuze</h3>
      <h4 class="summary__package-title">{{ State.selection.name }}</h4>
      <category-summary
        v-for="groupedCategory in groupedCategories"
        :key="groupedCategory.id"
        :groupedCategory="groupedCategory"
      />
      <price :price="State.total" :incentivePrice="State.incentivePrice" :OneTimePrice="State.oneTimePrice" />
    </div>

    <div v-if="networkCategories.NETWERKKOSTEN" class="block summary" style="margin-top: 40px; margin-bottom: 15px">
      <div class="summary__secondary-title">NETWERKKOSTEN</div>
      <category-summary
        v-for="groupedCategory in networkCategories"
        :key="groupedCategory.id"
        :groupedCategory="groupedCategory"
      />
    </div>
    <slot></slot>
  </div>
</template>

<script>
import State from '../state'
import CategorySummary from './category-summary'
import Price from '../components/price'

export default {
  data () {
    return { State }
  },
  components: { CategorySummary, Price },
  computed: {
    groupedCategories () {
      const { NETWERKKOSTEN, ...categories } = State.groupedCategories
      return categories
    },
    networkCategories: function () {
      const { NETWERKKOSTEN } = State.groupedCategories

      if (this.networkCategoriesHidden) {
        return false
      }

      return { NETWERKKOSTEN }
    },
    networkCategoriesHidden () {
      const { NETWERKKOSTEN } = State.groupedCategories

      var returnValue = 1
      console.log(NETWERKKOSTEN)
      if (NETWERKKOSTEN !== undefined) {
        NETWERKKOSTEN.children.map(child => {
          child.products.map(product => {
            if (
              product.extra_price_base === null && returnValue === null
            ) {
              returnValue = null
            } else {
              returnValue = 1
            }
          })
        })
      }
      if (returnValue === null) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.summary {
  position: relative;
  margin-left: 20px;
  border: solid 1px color('summaryheader');
}

div.summary__secondary-title {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  transform: translate(0, -100%);
  background: color('summaryheader');
  padding: 6px 20px;
  text-transform: uppercase;
  color: #fff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-weight: bold;
  font-size: 0.8em;
  letter-spacing: 1px;
  width: 180px;
  margin: 0 auto;
  text-align: center;
}

.summary__title {
  text-align: center;
  font-size: 25px;
  font-weight: 700;
  margin: 0;
  margin-bottom: 10px;
}

.summary__package-title {
  text-align: center;
  font-size: 1em;
  font-weight: 700;
  margin: 0;
  margin-bottom: 20px;

  &:after {
    content: "";
    display: block;
    width: 100px;
    height: 2px;
    background-color: color('summaryheader');
    margin: 15px auto;
  }
}
</style>
